import { Logout } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUserQuery } from '../api/gql';
import { useImpersonate } from '../hooks/useImpersonate';

export const ImpersonateControl = () => {
  const { t } = useTranslation();
  const { data } = useUserQuery();
  const { stopImpersonate, impersonateUserToken } = useImpersonate();
  return impersonateUserToken ? (
    <Box
      sx={{
        backgroundColor: 'warning.light',
        width: '100%',
        display: 'flex',
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000000,
        py: 0.5,
        px: 4,
        gap: 4,
        opacity: 0.9,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Typography variant={'caption'} fontWeight={'bold'}>
        {t('impersonation.description', {
          userName: `${data?.user.firstName} ${data?.user.lastName}`,
        })}
      </Typography>
      <Button startIcon={<Logout />} variant={'contained'} size={'small'} color={'secondary'} onClick={stopImpersonate}>
        {t('impersonation.stop')}
      </Button>
    </Box>
  ) : null;
};
